import { IcoTrash } from "assets/icons";
import colors from "colors";
import { Accordion, Button, Loading } from "components";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { TabComponentProps } from "../types";
import ApplicationDetailData from "./modules/ApplicationDetailData";
import CancelApplicationModal from "./modules/CancelApplicationModal";
import "./styles.scss";

type ApplicationDetailParams = {
	applicationId: string;
};

export default function ApplicationDetail(props: Readonly<TabComponentProps>) {
	const { application, loading } = props;
	const [cancelModalOpen, setCancelModalOpen] = useState(false);
	const { applicationId } = useParams<
		keyof ApplicationDetailParams
	>() as ApplicationDetailParams;

	const applicationDetails = application?.applicationDetails ?? [];
	const applicantDetails = application?.applicantDetails ?? [];
	const accordionContentSections = useMemo(() => {
		if (!application) return [];
		return [
			{
				title: "Detalhes da solicitação",
				items: [
					{
						title: "Dados da intervenção",
						value: "application-details",
						content: (
							<div className="data-container">
								<ApplicationDetailData applicationData={applicationDetails} />
								<div className="description-field">
									<div className="description-title">Descrição:</div>
									<div className="description-content overflow-wrap--anywhere">
										{application?.description}
									</div>
								</div>
							</div>
						)
					},
					{
						title: "Dados do proprietário",
						value: "applicant-details",
						content: (
							<div className="data-container">
								<ApplicationDetailData applicationData={applicantDetails} />
							</div>
						)
					}
				]
			}
		];
	}, [application]);

	const openCancelModal = () => setCancelModalOpen(true);

	const canCancel = useMemo(() => {
		return !application?.isInFinalStatus();
	}, [application]);

	return (
		<div className="application-detail-page">
			{loading || !application ? (
				<Loading />
			) : (
				<div className="application-detail-wrapper">
					<div className="application-detail-content scrollbar-width--thin">
						<Accordion
							sections={accordionContentSections}
							defaultValue={["application-details"]}
						/>
						<div className="button-footer">
							{canCancel && (
								<div className="md:border-t-2 border-t-neutral-high-200 md:pt-4 md:pl-4 flex flex-row justify-between items-center">
									<p className="text-sm max-md:hidden">Cancelar solicitação</p>
									<Button
										hierarchy="secondary"
										size="small"
										disabled={loading}
										onClick={openCancelModal}
										className="cancel-button"
									>
										<IcoTrash color={colors["feedback-negative"]["pure-500"]} />{" "}
										<p>Cancelar</p>
									</Button>
								</div>
							)}
						</div>
					</div>
				</div>
			)}

			<CancelApplicationModal
				applicationId={applicationId}
				isOpen={cancelModalOpen}
				onClose={() => setCancelModalOpen(false)}
			/>
		</div>
	);
}
